import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { formatWhatsAppText } from "../../../../../components/utils";
import Loader from "../../../../../components/Loader";
import useAuth from "../../../../../components/hooks/useAuth";

const ViewBroadcastOperations = ({ broadcastId }) => {

  const [operations, setOperations] = useState([]);
  const [selectedOperation, setSelectedOperation] = useState(null);
  const [loading, setLoading] = useState(null);
  const navigate = useNavigate();
  const { sidebarOpen, getApi, postApi, deleteApi } = useAuth();

      const listMessages = async () => {
    setLoading(true)
     let response = await getApi("/api/v1/wpbroadcast/message/"+broadcastId, {
      
      });

       if (response) {
        setOperations(response.lista);
       }
      setLoading(false)
  }

  
  useEffect(() => {
    listMessages();
  }, []);

  const getTypeIcon = (type) => {
    switch (type) {
      case "text": return "💬";
      case "image": return "🖼️";
      case "video": return "🎥";
      case "audio": return "🎧";
      case "document": return "📄";
      default: return "📦";
    }
  };

  const getProgress = (sent, total) => {
    return total ? Math.round((sent / total) * 100) : 0;
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "sent": return "#2e7d32";
      case "failed": return "#c62828";
      case "pending": return "#ed6c02";
      default: return "#666";
    }
  };

  const renderContent = (op) => {
    const body = op.body;

    switch (op.message_type) {
      case "text":
        return <div style={message}>{formatWhatsAppText(body.text)}</div>;

      case "image":
        return (
          <div style={mediaBox}>
            <img src={body.url} style={media} alt="" />
            {body.caption && <div style={caption}>{formatWhatsAppText(body.caption)}</div>}
          </div>
        );

      case "video":
        return (
          <div style={mediaBox}>
            <video src={body.url} controls style={media} />
            {body.caption && <div style={caption}>{formatWhatsAppText(body.caption)}</div>}
          </div>
        );

      case "audio":
        return (
          <div style={mediaBox}>
            <audio src={body.url} controls />
          </div>
        );

      case "document":
        return (
          <div style={mediaBox}>
            <a href={body.url} target="_blank" rel="noreferrer" style={docLink}>
              📄 {body.fileName || "Abrir documento"}
            </a>
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <div style={container}>

      {/* HEADER */}
      <div style={topBar}>
        <div>
          <div style={title}>Operações do Broadcast</div>
          <div style={subtitle}>Mensagens enviadas e status por contato</div>
        </div>

        <button
          onClick={() => navigate(`/broadcast/${broadcastId}/criar/message`)}
          style={btnPrimary}
        >
          + Nova operação
        </button>
      </div>

      {/* LISTA */}
      <div style={list}>
        {operations.map((op) => {

          const progress = getProgress(op.stats.sent, op.stats.total);

          return (
            <div key={op.id} style={card}>

              {/* HEADER */}
              <div style={cardHeader}>
                <strong>
                  {getTypeIcon(op.message_type)} {op.message_type}
                </strong>
                <span style={date}>
                  {new Date(op.dispatch_date).toLocaleString()}
                </span>
              </div>

              {/* CONTENT */}
              {renderContent(op)}

              {/* STATS */}
              <div style={statsBox}>
                <div style={stat}>👥 {op.stats.total}</div>
                <div style={{ ...stat, color: "#2e7d32" }}>✅ {op.stats.sent}</div>
                <div style={{ ...stat, color: "#c62828" }}>❌ {op.stats.failed}</div>
                <div style={{ ...stat, color: "#ed6c02" }}>⏳ {op.stats.pending}</div>
              </div>

              {/* PROGRESS */}
              <div style={progressBar}>
                <div style={{ ...progressFill, width: `${progress}%` }} />
              </div>

              <div style={footer}>
                <span>{progress}% enviados</span>

                <button
                  style={btnView}
                  onClick={() => setSelectedOperation(op)}
                >
                  Ver destinatários
                </button>
              </div>

            </div>
          );
        })}
      </div>
        {loading && <Loader />}

      {/* MODAL */}
      {selectedOperation && (
        <div style={overlay}>
          <div style={modal}>

            <div style={modalHeader}>
              <strong>Destinatários</strong>
              <button onClick={() => setSelectedOperation(null)} style={closeBtn}>✕</button>
            </div>

            <div style={recipientList}>
              {selectedOperation.recipients.map((r, i) => (
                <div key={i} style={recipientItem}>
                  <span>{r.phone_number}</span>
                  <span style={{
                    ...statusBadge,
                    background: getStatusColor(r.status)
                  }}>
                    {r.status}
                  </span>
                </div>
              ))}
            </div>

          </div>
        </div>
      )}

    </div>
  );
};

/* ================= STYLES ================= */

const container = { padding: 20 };

const topBar = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: 20
};

const title = { fontSize: 20, fontWeight: "bold" };
const subtitle = { fontSize: 13, color: "#777" };

const btnPrimary = {
  background: "#51a197",
  color: "#fff",
  border: "none",
  padding: "10px 16px",
  borderRadius: 8,
  fontWeight: "bold",
  cursor: "pointer"
};

const list = {
  display: "flex",
  flexDirection: "column",
  gap: 14
};

const card = {
  background: "#fff",
  borderRadius: 12,
  padding: 16,
  boxShadow: "0 4px 20px rgba(0,0,0,0.08)"
};

const cardHeader = {
  display: "flex",
  justifyContent: "space-between",
  marginBottom: 10
};

const date = { fontSize: 12, color: "#777" };

const message = {
  background: "#f5f5f5",
  padding: 10,
  borderRadius: 8,
  marginBottom: 10
};

const mediaBox = { marginBottom: 10 };

const media = {
  maxWidth: "100%",
  borderRadius: 8
};

const caption = {
  marginTop: 6,
  fontSize: 13
};

const docLink = {
  color: "#1976d2",
  textDecoration: "none",
  fontWeight: "bold"
};

const statsBox = {
  display: "flex",
  justifyContent: "space-between",
  marginBottom: 10
};

const stat = {
  fontSize: 13
};

const progressBar = {
  height: 6,
  background: "#eee",
  borderRadius: 10,
  overflow: "hidden"
};

const progressFill = {
  height: "100%",
  background: "#51a197"
};

const footer = {
  marginTop: 8,
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  fontSize: 12,
  color: "#777"
};

const btnView = {
  background: "#eee",
  border: "none",
  padding: "6px 10px",
  borderRadius: 6,
  cursor: "pointer",
  fontSize: 12
};

/* MODAL */

const overlay = {
  position: "fixed",
  inset: 0,
  background: "rgba(0,0,0,0.4)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center"
};

const modal = {
  width: 400,
  background: "#fff",
  borderRadius: 12,
  padding: 20,
  maxHeight: "70vh",
  overflowY: "auto"
};

const modalHeader = {
  display: "flex",
  justifyContent: "space-between",
  marginBottom: 10
};

const closeBtn = {
  border: "none",
  background: "transparent",
  cursor: "pointer"
};

const recipientList = {};

const recipientItem = {
  display: "flex",
  justifyContent: "space-between",
  padding: "6px 0",
  borderBottom: "1px solid #eee"
};

const statusBadge = {
  color: "#fff",
  padding: "2px 8px",
  borderRadius: 12,
  fontSize: 12
};

export default ViewBroadcastOperations;